import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalConvenienceStoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_convenience_store"}/>
}
